export enum BesonderePersonengruppe {
  BEAMTE = 'Beamte',
  BEAMTE_AUSZUBILDENDE = 'Beamte Auszubildende',
  BEAMTE_ALTERSTEILZEIT = 'Beamte Altersteilzeit',
  LEITENDE_ANGESTELLTE = 'Leitende Angestellte (auch Geschäftsführer/-innen einer GmbH und Vorstände einer AG) mit einem Arbeitsvertrag',
  SAISON_GELEGENHEITSARBEITER_IN = 'Saision- und Gelegenheitsarbeiter/innen',
}
